import React, { useState } from 'react';
import './PrintedBlindsContent.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const tabData = {
    Roller: {
        slides: [
            "/Assets/PrintedBlindsImages/roller-inspiration-26.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-27.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-29.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-30.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-31.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-32.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-33.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-35.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-36.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-38.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-39.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-40.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-41.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-42.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-43.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-44.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-46.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-47.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-48.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-49.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-50.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-51.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-52.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-54.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-55.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-56.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-57.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-61.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-64.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-65.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-66.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-70.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-01.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-02.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-03.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-04.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-05.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-06.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-08.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-09.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-10.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-11.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-12.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-13.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-14.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-16.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-17.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-18.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-19.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-20.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-21.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-22.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-23.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-24.webp",
            "/Assets/PrintedBlindsImages/roller-inspiration-25.webp"
        ],
        description: `Marvel Blinds provides a huge range of printed blinds which can match your interior and enhance your room. Marvel Roller blinds can enlighten any space with its colour, design and texture. Give a look of royal palace or a fairy tale with huge range of Roller printed blinds; you name it we have it.`,
    },
    Roman: {
        slides: [
            '/Assets/PrintedBlindsImages/roman-inspiration-1.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-2.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-3.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-4.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-5.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-6.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-7.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-8.webp',
            '/Assets/PrintedBlindsImages/roman-inspiration-9.webp',
        ],
        description: `Marvel Roman Blinds are versatile and give contemporary look to your interior. With range of Roman Printed Blinds decorate your interior with designs from animation, florals, abstracts and many more. In addition, the fold by fold raising property of Roman blinds gives a unique edge to the interior.`,
    },
    Panel: {
        slides: [
            '/Assets/PrintedBlindsImages/panel-inspiration-1.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-2.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-3.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-4.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-5.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-6.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-7.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-8.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-9.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-10.webp',
            '/Assets/PrintedBlindsImages/panel-inspiration-11.webp',
        ],
        description: `Marvel Panel printed blinds transform your space and give it a contemporary look. Marvel Panel printed blinds can turn your interior from simple to amazing and transform it into space, jungle and also a royal stage. From children to adults, from schools to palaces, Marvel printed range has something for everyone.`,
    },
};

const PrintedBlindsContent = () => {
    const [activeTab, setActiveTab] = useState('Roller');

    return (
        <div className="Automation-pg-content">
            <div className="automation-container">
                <div className="Automation-tab-buttons">
                    {Object.keys(tabData).map((tab) => (
                        <button
                            key={tab}
                            className={activeTab === tab ? 'active' : ''}
                            onClick={() => setActiveTab(tab)}
                        >
                            <span> {tab}</span>
                        </button>
                    ))}
                </div>

                <div className="Automation-tab-content">
                    <Swiper
                        loop={true}
                        autoplay={{ delay: 5000, disableOnInteraction: false }} navigation={true}
                        modules={[Navigation, Autoplay]}
                        className="automation-swiper"
                    >
                        {tabData[activeTab].slides.map((img, index) => (
                            <SwiperSlide key={index}>
                                <img src={img} alt={`${activeTab} ${index + 1}`} className="Slider-img" />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <p className="A-tab-description">{tabData[activeTab].description}</p>
                </div>
            </div>
        </div>
    );
};

export default PrintedBlindsContent;
